import { FiHeart } from "react-icons/fi";
import { profile } from "../../data/profile";
import { SOCIAL_ICONS } from "./nav";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <span className="site-footer-credit">
        Built with <FiHeart className="footer-heart" /> by {profile.shortName}
      </span>
      <span className="site-footer-copy">© {year} {profile.name}</span>
      <div className="site-footer-socials">
        {profile.socials.map((s) => {
          const Icon = SOCIAL_ICONS[s.id];
          return (
            <a
              key={s.id}
              href={s.url}
              target="_blank"
              rel="noreferrer"
              aria-label={s.label}
              title={s.label}
            >
              {Icon && <Icon />}
            </a>
          );
        })}
      </div>
    </footer>
  );
};

export default Footer;
